import useApprovalConditions from '../../hooks/useApprovalConditions';
import { ApprovalSummaryI18nAllApproved, ApprovalSummaryI18nPartiallyApproved } from '../i18n/ApprovalSummaryI18n';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';

// This only shows message for an Approver who has approved
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalSummary() {
  const {
    isApproved,
    isNotStarted,
    isUserStepApproved
  } = useApprovalConditions();
  if (isNotStarted) {
    return null;
  }
  if (!isUserStepApproved) {
    return null;
  }
  return /*#__PURE__*/_jsx(Paragraph, {
    marginBlockEnd: "0",
    marginBlockStart: "300",
    children: isApproved ? /*#__PURE__*/_jsx(ApprovalSummaryI18nAllApproved, {}) : /*#__PURE__*/_jsx(ApprovalSummaryI18nPartiallyApproved, {})
  });
}
export default ApprovalSummary;